declare var IsMBNIndicatorEnabled:boolean;

export default function overrideIfMinBetNumberEnabled(overrideFn: Function) {
    if (!overrideFn) { return; }
    if (!IsMBNIndicatorEnabled) { return; }

    overrideFn();
}